// import React, { useState } from 'react'
// import { Box, Typography, Stack, TextField, Button } from '@mui/material'
// import { motion, useReducedMotion } from 'framer-motion'
// import { useTranslation } from 'react-i18next'
// import ArrowBackIcon from '@mui/icons-material/ArrowBack'
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

// // صورة العقار - بتتحط كخلفية للسيكشن كله بتدرج لوني (duotone) بلون البراند
// import contactBg from '../Images/homeimage.webp'

// export const HomeContactUs = () => {
//   const { t, i18n } = useTranslation()
//   const isArabic = (i18n.language || 'ar').startsWith('ar')
//   const prefersReducedMotion = useReducedMotion()

//   const headingFont = isArabic ? "'El Messiri', serif" : "'Bodoni Moda', serif"
//   const bodyFont = isArabic ? "'IBM Plex Sans Arabic', sans-serif" : "'Manrope', sans-serif"

//   const ink = '#141312'
//   const ivory = '#EDE7DC'
//   const ivoryMuted = 'rgba(237,231,220,0.56)'
//   const bronze = '#B8935A'
//   const bronzeLine = 'rgba(184,147,90,0.32)'
//   const maroon = '#7A2E3A'
//   const blogsBg = '#2B2B2B'

//   // منطقة التراكب مع البلوجز اللي فوق
//   const TOP_OVERLAP = { xs: 130, md: 220 }

//   const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' })
//   const [submitted, setSubmitted] = useState(false)

//   const handleChange = (field) => (e) => {
//     setForm((prev) => ({ ...prev, [field]: e.target.value }))
//   }

//   const handleSubmit = (e) => {
//     e.preventDefault()
//     console.log('Contact form submitted:', form)
//     setSubmitted(true)
//     setForm({ name: '', email: '', phone: '', message: '' })
//     setTimeout(() => setSubmitted(false), 4000)
//   }

//   const contactRows = [
//     { label: t('contactUs.addressLabel', 'العنوان'), value: t('contactUs.address', 'برج الأعمال، خليج الأعمال، دبي، الإمارات') },
//     { label: t('contactUs.phoneLabel', 'التليفون'), value: '+971 58 553 5444', href: 'tel:+971 58 553 5444', dir: 'ltr' },
//     { label: t('contactUs.emailLabel', 'البريد الإلكتروني'), value: 'info@lyorauraproperties.com', href: 'mailto:info@lyorauraproperties.com' },
//     { label: t('contactUs.hoursLabel', 'أوقات العمل'), value: t('contactUs.hours', 'السبت - الخميس، 9 صباحًا - 7 مساءً') },
//   ]

//   const fieldStyles = {
//     '& .MuiInput-underline:before': { borderBottomColor: 'rgba(237,231,220,0.22)' },
//     '& .MuiInput-underline:hover:before': { borderBottomColor: `${bronze} !important` },
//     '& .MuiInput-underline:after': { borderBottomColor: bronze },
//     '& .MuiInputLabel-root': { fontFamily: bodyFont, color: ivoryMuted, fontSize: '0.95rem' },
//     '& .MuiInputLabel-root.Mui-focused': { color: bronze },
//     '& .MuiInputBase-input': { fontFamily: bodyFont, color: ivory, fontSize: '1rem', paddingTop: '10px' },
//     '& textarea': { fontFamily: bodyFont, color: ivory },
//   }

//   const ArrowIcon = isArabic ? ArrowBackIcon : ArrowForwardIcon

//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         bgcolor: ink,
//         mt: { xs: -14, md: -22 }, // مسحوب لفوق جوه البلوجز
//         pt: { xs: '184px', md: '288px' }, // 130+54 / 220+68 - يستوعب منطقة التراكب مع البلوجز + مسافة طبيعية
//         // مساحة فاضية حقيقية وكافية في الآخر، أكبر من منطقة تراكب الفوتر (160/260px)
//         // عشان الفوتر لما يتراكب معاها يفضل جوه المساحة الفاضية دي، من غير ما يلمس النص
//         pb: { xs: '200px', md: '300px' },
//         overflow: 'hidden',
//         zIndex: 1,
//       }}
//     >
//       {/* صورة الخلفية - duotone بلون البراند تغطي السيكشن كله */}
//       <Box
//         component={motion.img}
//         src={contactBg}
//         alt=""
//         initial={prefersReducedMotion ? false : { scale: 1.08 }}
//         whileInView={{ scale: 1 }}
//         viewport={{ once: true, amount: 0.4 }}
//         transition={{ duration: 1.6, ease: 'easeOut' }}
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           width: '100%',
//           height: '100%',
//           objectFit: 'cover',
//           filter: 'grayscale(1) contrast(1.15) brightness(0.45)',
//           zIndex: 0,
//         }}
//       />
//       <Box
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           background: `linear-gradient(180deg, ${ink}D9, ${ink}F2 55%, ${ink})`,
//           mixBlendMode: 'multiply',
//           zIndex: 1,
//         }}
//       />
//       <Box
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           background: `${maroon}33`,
//           mixBlendMode: 'color',
//           zIndex: 1,
//         }}
//       />

//       {/* الستارة العلوية - بلون البلوجز، بتختفي تدريجيًا وبتكشف خلفية الكونتاكت */}
//       <Box
//         aria-hidden
//         sx={{
//           position: 'absolute',
//           left: 0,
//           right: 0,
//           top: 0,
//           height: TOP_OVERLAP,
//           pointerEvents: 'none',
//           background: `linear-gradient(180deg,
//             ${blogsBg} 0%,
//             rgba(43,43,43,0.85) 15%,
//             rgba(43,43,43,0.55) 35%,
//             rgba(43,43,43,0.25) 60%,
//             rgba(43,43,43,0.08) 80%,
//             rgba(43,43,43,0) 100%)`,
//           zIndex: 1,
//         }}
//       />

//       {/* ملحوظة: مفيش أي fade في الآخر هنا - المساحة الفاضية (pb) كافية،
//           والفوتر هو اللي هيعمل التراكب البصري بستارته الخاصة */}

//       <Box
//         sx={{
//           position: 'relative',
//           zIndex: 2,
//           maxWidth: 1360,
//           mx: 'auto',
//         }}
//       >
//         {/* المحتوى الرئيسي */}
//         <Box
//           component={motion.div}
//           initial={prefersReducedMotion ? false : { opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true, amount: 0.25 }}
//           transition={{ duration: 0.7, ease: 'easeOut' }}
//           sx={{
//             flex: 1,
//             display: 'flex',
//             flexDirection: { xs: 'column', md: 'row' },
//             px: { xs: 3, md: 7 },
//             py: { xs: 0, md: 10 },
//           }}
//         >
//           {/* عمود البيانات */}
//           <Box
//             sx={{
//               flex: '0 0 auto',
//               width: { xs: '100%', md: 340 },
//               pe: { md: 6 },
//               pt: { xs: 6, md: 0 },
//             }}
//           >
//             <Typography
//               sx={{
//                 fontFamily: bodyFont,
//                 color: bronze,
//                 fontSize: '0.95rem',
//                 fontWeight: 500,
//                 mb: 1.5,
//               }}
//             >
//               {t('contactUs.eyebrow', 'تواصل معنا')}
//             </Typography>
//             <Typography
//               sx={{
//                 fontFamily: headingFont,
//                 fontWeight: isArabic ? 700 : 500,
//                 fontSize: { xs: '2rem', md: '2.5rem' },
//                 color: ivory,
//                 lineHeight: 1.2,
//                 mb: 2.5,
//               }}
//             >
//               {t('contactUs.title', 'لنتحدث عن مستقبل استثمارك')}
//             </Typography>
//             <Typography
//               sx={{
//                 fontFamily: bodyFont,
//                 color: ivoryMuted,
//                 fontSize: '0.95rem',
//                 lineHeight: 1.9,
//                 mb: 5,
//                 maxWidth: 380,
//               }}
//             >
//               {t(
//                 'contactUs.subtitle',
//                 'من اختيار العقار المناسب لحد توقيع العقد، فريقنا معاك في كل خطوة بخبرة ووضوح.'
//               )}
//             </Typography>

//             <Stack sx={{ borderTop: `1px solid ${bronzeLine}` }}>
//               {contactRows.map((row) => (
//                 <Box
//                   key={row.label}
//                   sx={{
//                     py: 2.25,
//                     borderBottom: `1px solid ${bronzeLine}`,
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       fontFamily: bodyFont,
//                       color: ivoryMuted,
//                       fontSize: '0.78rem',
//                       mb: 0.6,
//                     }}
//                   >
//                     {row.label}
//                   </Typography>
//                   {row.href ? (
//                     <Typography
//                       component="a"
//                       href={row.href}
//                       sx={{
//                         fontFamily: bodyFont,
//                         color: ivory,
//                         fontSize: '1rem',
//                         fontWeight: 500,
//                         textDecoration: 'none',
//                         direction: row.dir || 'inherit',
//                         display: 'inline-block',
//                         borderBottom: '1px solid transparent',
//                         transition: 'border-color 0.2s ease',
//                         '&:hover': { borderBottomColor: bronze },
//                       }}
//                     >
//                       {row.value}
//                     </Typography>
//                   ) : (
//                     <Typography sx={{ fontFamily: bodyFont, color: ivory, fontSize: '1rem', fontWeight: 500 }}>
//                       {row.value}
//                     </Typography>
//                   )}
//                 </Box>
//               ))}
//             </Stack>
//           </Box>

//           {/* الفاصل الرأسي */}
//           <Box
//             sx={{
//               display: { xs: 'none', md: 'block' },
//               width: '1px',
//               alignSelf: 'stretch',
//               bgcolor: bronzeLine,
//               mx: 5,
//             }}
//           />
//           <Box sx={{ display: { xs: 'block', md: 'none' }, height: '1px', bgcolor: bronzeLine, my: 6 }} />

//           {/* عمود الفورم */}
//           <Box
//             component="form"
//             onSubmit={handleSubmit}
//             sx={{
//               flex: 1,
//               pt: { xs: 0, md: 0 },
//               pb: { xs: 8, md: 0 },
//             }}
//           >
//             <Typography
//               sx={{
//                 fontFamily: headingFont,
//                 fontWeight: 600,
//                 fontSize: '1.35rem',
//                 color: ivory,
//                 mb: 4,
//               }}
//             >
//               {t('contactUs.formTitle', 'سجل بياناتك')}
//             </Typography>

//             <Stack spacing={4}>
//               <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
//                 <TextField
//                   fullWidth
//                   variant="standard"
//                   label={t('contactUs.form.name', 'الاسم بالكامل')}
//                   value={form.name}
//                   onChange={handleChange('name')}
//                   required
//                   sx={fieldStyles}
//                 />
//                 <TextField
//                   fullWidth
//                   variant="standard"
//                   type="tel"
//                   label={t('contactUs.form.phone', 'رقم الهاتف')}
//                   value={form.phone}
//                   onChange={handleChange('phone')}
//                   required
//                   sx={fieldStyles}
//                 />
//               </Stack>
//               <TextField
//                 fullWidth
//                 variant="standard"
//                 type="email"
//                 label={t('contactUs.form.email', 'البريد الإلكتروني')}
//                 value={form.email}
//                 onChange={handleChange('email')}
//                 required
//                 sx={fieldStyles}
//               />
//               <TextField
//                 fullWidth
//                 variant="standard"
//                 multiline
//                 minRows={3}
//                 label={t('contactUs.form.message', 'رسالتك')}
//                 value={form.message}
//                 onChange={handleChange('message')}
//                 required
//                 sx={fieldStyles}
//               />

//               <Box sx={{ pt: 2 }}>
//                 <Button
//                   type="submit"
//                   endIcon={<ArrowIcon sx={{ fontSize: 18 }} />}
//                   sx={{
//                     fontFamily: bodyFont,
//                     color: submitted ? ink : ivory,
//                     bgcolor: submitted ? bronze : 'transparent',
//                     border: `1px solid ${submitted ? bronze : bronzeLine}`,
//                     borderRadius: '2px',
//                     px: 4,
//                     py: 1.4,
//                     fontSize: '0.95rem',
//                     fontWeight: 500,
//                     transition: 'all 0.25s ease',
//                     '&:hover': {
//                       bgcolor: bronze,
//                       borderColor: bronze,
//                       color: ink,
//                     },
//                   }}
//                 >
//                   {submitted
//                     ? t('contactUs.form.sent', 'تم الإرسال بنجاح')
//                     : t('contactUs.form.submit', 'إرسال الرسالة')}
//                 </Button>
//               </Box>
//             </Stack>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   )
// }




















// after send to gmail

import React, { useState } from 'react'
import { Box, Typography, Stack, TextField, Button, Alert } from '@mui/material'
import { motion, useReducedMotion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import emailjs from '@emailjs/browser'
import axios from 'axios'
// صورة العقار - بتتحط كخلفية للسيكشن كله بتدرج لوني (duotone) بلون البراند
import contactBg from '../Images/homeimage.webp'

// 🔑 بيانات EmailJS - نفس الحساب المستخدم في صفحة Contact Us
// 🔑 بيانات EmailJS - عدّل القيم دي ببيانات حسابك بعد إنشائه على emailjs.com
const EMAILJS_SERVICE_ID = 'service_asaf6vt'
const EMAILJS_TEMPLATE_ID = 'template_93avjxb'
const EMAILJS_PUBLIC_KEY = '5GSKB0HmL516-WxJY'
// 🔗 نفس الراوت المستخدم في صفحة Contact Us والداشبورد
const LEADS_URL = 'https://lyorauraproperties-api.onrender.com/api/v1/Leads'
export const HomeContactUs = () => {
  const { t, i18n } = useTranslation()
  const isArabic = (i18n.language || 'ar').startsWith('ar')
  const prefersReducedMotion = useReducedMotion()

  const headingFont = isArabic ? "'El Messiri', serif" : "'Bodoni Moda', serif"
  const bodyFont = isArabic ? "'IBM Plex Sans Arabic', sans-serif" : "'Manrope', sans-serif"

  const ink = '#141312'
  const ivory = '#EDE7DC'
  const ivoryMuted = 'rgba(237,231,220,0.56)'
  const bronze = '#B8935A'
  const bronzeLine = 'rgba(184,147,90,0.32)'
  const maroon = '#7A2E3A'
  const blogsBg = '#2B2B2B'

  // منطقة التراكب مع البلوجز اللي فوق
  const TOP_OVERLAP = { xs: 130, md: 220 }

  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' })
  const [status, setStatus] = useState('idle') // idle | sending | success | error

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }))
  }

  const handleSubmit = async (e) => {
  e.preventDefault()
  setStatus('sending')

  try {
    // 1) نسجل الليد في الداتابيز الأول (نفس منطق صفحة Contact Us)
    await axios.post(LEADS_URL, {
      name: form.name,
      email: form.email,
      phone: form.phone,
      country_code: '+971', // ✅ قيمة افتراضية لأن الفورم هنا مفيهوش حقل منفصل لكود الدولة
      message: form.message,
      registerPlace: 'home',
    })

    // 2) بعد ما يتسجل بنجاح، نبعت إيميل تنبيه - لو فشل الإيميل مش هيوقف العملية
    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          title: isArabic ? 'رسالة جديدة من الصفحة الرئيسية' : 'New message from the homepage',
          name: form.name,
          time: new Date().toLocaleString(isArabic ? 'ar-AE' : 'en-AE'),
          message: form.message,
          phone: form.phone,
          email: form.email,
        },
        EMAILJS_PUBLIC_KEY,
      )
    } catch (emailErr) {
      console.error('Email notification failed (lead was still saved):', emailErr)
    }

    setStatus('success')
    setForm({ name: '', email: '', phone: '', message: '' })
    setTimeout(() => setStatus('idle'), 5000)
  } catch (err) {
    console.error('Home contact form lead submission error:', err)
    setStatus('error')
    setTimeout(() => setStatus('idle'), 5000)
  }
}

  const contactRows = [
    { label: t('contactUs.addressLabel', 'العنوان'), value: t('contactUs.address', 'برج الأعمال، خليج الأعمال، دبي، الإمارات') },
    { label: t('contactUs.phoneLabel', 'التليفون'), value: '+971585535444', href: 'tel:+971585535444', dir: 'ltr' },
    { label: t('contactUs.emailLabel', 'البريد الإلكتروني'), value: 'info@lyorauraproperties.com', href: 'mailto:info@lyorauraproperties.com' },
    { label: t('contactUs.hoursLabel', 'أوقات العمل'), value: t('contactUs.hours', 'السبت - الخميس، 9 صباحًا - 7 مساءً') },
  ]

  const fieldStyles = {
    '& .MuiInput-underline:before': { borderBottomColor: 'rgba(237,231,220,0.22)' },
    '& .MuiInput-underline:hover:before': { borderBottomColor: `${bronze} !important` },
    '& .MuiInput-underline:after': { borderBottomColor: bronze },
    '& .MuiInputLabel-root': { fontFamily: bodyFont, color: ivoryMuted, fontSize: '0.95rem' },
    '& .MuiInputLabel-root.Mui-focused': { color: bronze },
    '& .MuiInputBase-input': { fontFamily: bodyFont, color: ivory, fontSize: '1rem', paddingTop: '10px' },
    '& textarea': { fontFamily: bodyFont, color: ivory },
  }

  const ArrowIcon = isArabic ? ArrowBackIcon : ArrowForwardIcon

  return (
    <Box
      sx={{
        position: 'relative',
        bgcolor: ink,
        mt: { xs: -14, md: -22 }, // مسحوب لفوق جوه البلوجز
        pt: { xs: '184px', md: '288px' }, // 130+54 / 220+68 - يستوعب منطقة التراكب مع البلوجز + مسافة طبيعية
        // مساحة فاضية حقيقية وكافية في الآخر، أكبر من منطقة تراكب الفوتر (160/260px)
        // عشان الفوتر لما يتراكب معاها يفضل جوه المساحة الفاضية دي، من غير ما يلمس النص
        pb: { xs: '200px', md: '300px' },
        overflow: 'hidden',
        zIndex: 1,
      }}
    >
      {/* صورة الخلفية - duotone بلون البراند تغطي السيكشن كله */}
      <Box
        component={motion.img}
        src={contactBg}
        alt=""
        initial={prefersReducedMotion ? false : { scale: 1.08 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 1.6, ease: 'easeOut' }}
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: 'grayscale(1) contrast(1.15) brightness(0.45)',
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: `linear-gradient(180deg, ${ink}D9, ${ink}F2 55%, ${ink})`,
          mixBlendMode: 'multiply',
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: `${maroon}33`,
          mixBlendMode: 'color',
          zIndex: 1,
        }}
      />

      {/* الستارة العلوية - بلون البلوجز، بتختفي تدريجيًا وبتكشف خلفية الكونتاكت */}
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          height: TOP_OVERLAP,
          pointerEvents: 'none',
          background: `linear-gradient(180deg,
            ${blogsBg} 0%,
            rgba(43,43,43,0.85) 15%,
            rgba(43,43,43,0.55) 35%,
            rgba(43,43,43,0.25) 60%,
            rgba(43,43,43,0.08) 80%,
            rgba(43,43,43,0) 100%)`,
          zIndex: 1,
        }}
      />

      {/* ملحوظة: مفيش أي fade في الآخر هنا - المساحة الفاضية (pb) كافية،
          والفوتر هو اللي هيعمل التراكب البصري بستارته الخاصة */}

      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          maxWidth: 1360,
          mx: 'auto',
        }}
      >
        {/* المحتوى الرئيسي */}
        <Box
          component={motion.div}
          initial={prefersReducedMotion ? false : { opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            px: { xs: 3, md: 7 },
            py: { xs: 0, md: 10 },
          }}
        >
          {/* عمود البيانات */}
          <Box
            sx={{
              flex: '0 0 auto',
              width: { xs: '100%', md: 340 },
              pe: { md: 6 },
              pt: { xs: 6, md: 0 },
            }}
          >
            <Typography
              sx={{
                fontFamily: bodyFont,
                color: bronze,
                fontSize: '0.95rem',
                fontWeight: 500,
                mb: 1.5,
              }}
            >
              {t('contactUs.eyebrow', 'تواصل معنا')}
            </Typography>
            <Typography
              sx={{
                fontFamily: headingFont,
                fontWeight: isArabic ? 700 : 500,
                fontSize: { xs: '2rem', md: '2.5rem' },
                color: ivory,
                lineHeight: 1.2,
                mb: 2.5,
              }}
            >
              {t('contactUs.title', 'لنتحدث عن مستقبل استثمارك')}
            </Typography>
            <Typography
              sx={{
                fontFamily: bodyFont,
                color: ivoryMuted,
                fontSize: '0.95rem',
                lineHeight: 1.9,
                mb: 5,
                maxWidth: 380,
              }}
            >
              {t(
                'contactUs.subtitle',
                'من اختيار العقار المناسب لحد توقيع العقد، فريقنا معاك في كل خطوة بخبرة ووضوح.'
              )}
            </Typography>

            <Stack sx={{ borderTop: `1px solid ${bronzeLine}` }}>
              {contactRows.map((row) => (
                <Box
                  key={row.label}
                  sx={{
                    py: 2.25,
                    borderBottom: `1px solid ${bronzeLine}`,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: bodyFont,
                      color: ivoryMuted,
                      fontSize: '0.78rem',
                      mb: 0.6,
                    }}
                  >
                    {row.label}
                  </Typography>
                  {row.href ? (
                    <Typography
                      component="a"
                      href={row.href}
                      sx={{
                        fontFamily: bodyFont,
                        color: ivory,
                        fontSize: '1rem',
                        fontWeight: 500,
                        textDecoration: 'none',
                        direction: row.dir || 'inherit',
                        display: 'inline-block',
                        borderBottom: '1px solid transparent',
                        transition: 'border-color 0.2s ease',
                        '&:hover': { borderBottomColor: bronze },
                      }}
                    >
                      {row.value}
                    </Typography>
                  ) : (
                    <Typography sx={{ fontFamily: bodyFont, color: ivory, fontSize: '1rem', fontWeight: 500 }}>
                      {row.value}
                    </Typography>
                  )}
                </Box>
              ))}
            </Stack>
          </Box>

          {/* الفاصل الرأسي */}
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
              width: '1px',
              alignSelf: 'stretch',
              bgcolor: bronzeLine,
              mx: 5,
            }}
          />
          <Box sx={{ display: { xs: 'block', md: 'none' }, height: '1px', bgcolor: bronzeLine, my: 6 }} />

          {/* عمود الفورم */}
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              flex: 1,
              pt: { xs: 0, md: 0 },
              pb: { xs: 8, md: 0 },
            }}
          >
            <Typography
              sx={{
                fontFamily: headingFont,
                fontWeight: 600,
                fontSize: '1.35rem',
                color: ivory,
                mb: 4,
              }}
            >
              {t('contactUs.formTitle', 'سجل بياناتك')}
            </Typography>

            <Stack spacing={4}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
                <TextField
                  fullWidth
                  variant="standard"
                  label={t('contactUs.form.name', 'الاسم بالكامل')}
                  value={form.name}
                  onChange={handleChange('name')}
                  required
                  sx={fieldStyles}
                />
                <TextField
                  fullWidth
                  variant="standard"
                  type="tel"
                  label={t('contactUs.form.phone', 'رقم الهاتف')}
                  value={form.phone}
                  onChange={handleChange('phone')}
                  required
                  sx={fieldStyles}
                />
              </Stack>
              <TextField
                fullWidth
                variant="standard"
                type="email"
                label={t('contactUs.form.email', 'البريد الإلكتروني')}
                value={form.email}
                onChange={handleChange('email')}
                required
                sx={fieldStyles}
              />
              <TextField
                fullWidth
                variant="standard"
                multiline
                minRows={3}
                label={t('contactUs.form.message', 'رسالتك')}
                value={form.message}
                onChange={handleChange('message')}
                required
                sx={fieldStyles}
              />

              {status === 'success' && (
                <Alert severity="success" sx={{ fontFamily: bodyFont }}>
                  {isArabic ? 'تم إرسال بياناتك بنجاح، هنتواصل معاك قريبًا.' : 'Your details were sent successfully, we will contact you soon.'}
                </Alert>
              )}
              {status === 'error' && (
                <Alert severity="error" sx={{ fontFamily: bodyFont }}>
                  {isArabic ? 'حصل خطأ أثناء الإرسال، حاول مرة أخرى.' : 'Something went wrong while sending. Please try again.'}
                </Alert>
              )}

              <Box sx={{ pt: 2 }}>
                <Button
                  type="submit"
                  disabled={status === 'sending'}
                  endIcon={<ArrowIcon sx={{ fontSize: 18 }} />}
                  sx={{
                    fontFamily: bodyFont,
                    color: status === 'success' ? ink : ivory,
                    bgcolor: status === 'success' ? bronze : 'transparent',
                    border: `1px solid ${status === 'success' ? bronze : bronzeLine}`,
                    borderRadius: '2px',
                    px: 4,
                    py: 1.4,
                    fontSize: '0.95rem',
                    fontWeight: 500,
                    transition: 'all 0.25s ease',
                    '&:hover': {
                      bgcolor: bronze,
                      borderColor: bronze,
                      color: ink,
                    },
                    '&.Mui-disabled': {
                      color: ivoryMuted,
                      borderColor: bronzeLine,
                    },
                  }}
                >
                  {status === 'sending'
                    ? (isArabic ? 'جاري الإرسال...' : 'Sending...')
                    : status === 'success'
                    ? t('contactUs.form.sent', 'تم الإرسال بنجاح')
                    : t('contactUs.form.submit', 'إرسال الرسالة')}
                </Button>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}